module.exports = __webpack_public_path__ + "media/stylesheets/images/section_img_6-7063ecf4200ea6c70a42561fe9194368.jpg";